import React, { useState } from "react";
import "./MultiSelect.css";
import UserChip from "../user-chip/UserChip";

type Member = {
  id: string;
  name: string;
};

type Props = {
  allMembers: Member[];
  selectedMembers: Member[];
  onChange: (members: Member[]) => void;
  label?: string;
  searchType?: string;
};

const MultiSelect: React.FC<Props> = ({
  allMembers,
  selectedMembers,
  onChange,
  label = "Members",
  searchType = "Members",
}) => {
  const [search, setSearch] = useState("");
  const filteredMembers = allMembers.filter(
    (m) =>
      (m.name ?? "").toLowerCase().includes(search.toLowerCase()) &&
      !selectedMembers.some((sel) => sel.id === m.id),
  );

  const addMember = (member: Member) => {
    onChange([...selectedMembers, member]);
    setSearch("");
  };

  const removeMember = (id: string) => {
    onChange(selectedMembers.filter((m) => m.id !== id));
  };

  return (
    <div className="multiSelect-form-group">
      <label>
        {label} <span className="multiSelect-required">*</span>
      </label>
      <input
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search Name"
        className="multiSelect-input"
      />
      {search && (
        <div className="multiSelect-dropdown">
          {filteredMembers.length > 0 ? (
            filteredMembers.map((m) => (
              <div
                key={m.id}
                className="multiSelect-dropdown-item"
                onClick={() => addMember(m)}
              >
                {m.name}
              </div>
            ))
          ) : (
            <div className="multiSelect-dropdown-item multiSelect-no-result">
              No results
            </div>
          )}
        </div>
      )}

      {selectedMembers.length > 0 && (
        <div className="multiSelect-selected-members">
          <p>
            Selected {searchType} ({selectedMembers.length}):
          </p>
          <div className="multiSelect-member-chips">
            {selectedMembers.map((m) => (
              <UserChip
                key={m.id}
                id={m.id}
                userName={`${m.name}`}
                onClick={() => removeMember(m.id)}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiSelect;
